module.exports = __webpack_public_path__ + "media/events/event3-6076cced.jpg";